import React, { Fragment, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SUB_NAV_TEMPLATE } from '../types/templates/subNav';
import { dispatchSkyfireMethods, globals } from '../utils';
import * as menuStyles from '../views/Menu.scss';
export default function SubNavbar({ template }) {
    var _a;
    const { innerTemplate, subNavMenuItems } = template;
    const dispatch = useDispatch();
    const handleSelected = useCallback((onItemSelected, event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        dispatchSkyfireMethods(dispatch, template, onItemSelected);
    }, [dispatch, template]);
    const handleMenuItemClick = useCallback((menuItem, event) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        if (!isActive(menuItem)) {
            handleSelected(menuItem.primaryLink.onItemSelected);
        }
    }, [dispatch, template]);
    const { shouldShowSearchSuggestions } = useSelector((state) => state.SearchSuggestions);
    const isActive = (menuItem) => {
        var _a, _b;
        return globals.location.pathname === ((_b = (_a = menuItem) === null || _a === void 0 ? void 0 : _a.primaryLink) === null || _b === void 0 ? void 0 : _b.deeplink);
    };
    const renderSubNavItem = (menuItem, idx) => (React.createElement("li", { id: `subnavMenuItem${idx + 1}`, className: [
            menuStyles.menubarMenuItem,
            isActive(menuItem) ? menuStyles.selected : '',
        ].join(' '), onClick: handleMenuItemClick.bind(this, menuItem) },
        React.createElement("div", { className: isActive(menuItem) ? menuStyles.hidden : '' },
            React.createElement("music-link", { kind: "secondary", href: menuItem.primaryLink.deeplink }, menuItem.text)),
        React.createElement("div", { className: isActive(menuItem) ? '' : menuStyles.hidden }, menuItem.text)));
    if (((_a = innerTemplate) === null || _a === void 0 ? void 0 : _a.interface) === SUB_NAV_TEMPLATE
        && !shouldShowSearchSuggestions && !innerTemplate.shouldHideSubNav) {
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: menuStyles.menubar, id: "subnav" },
                React.createElement("ul", { className: menuStyles.menubarMenuItems }, subNavMenuItems.map(renderSubNavItem))),
            React.createElement("div", { id: "verticalSubnav", className: menuStyles.menubarVertical }, isActive(subNavMenuItems[0]) &&
                subNavMenuItems
                    .filter((item) => item.isItemVisibleVertical)
                    .map((menuItem, index) => (React.createElement("music-list-item", { id: `verticalSubnavMenuItem${index + 1}`, className: 'hydrated indent', size: 'medium', "has-border": true, "primary-text": menuItem.text, "show-chevron": true, onClick: handleSelected.bind(this, menuItem.primaryLink.onItemSelected) }))))));
    }
    return null;
}
